import { Launch as ExportIcon } from "@mui/icons-material";
import _uniq from "lodash/uniq";
import { Fragment, useState } from "react";
import { LinearProgress, useTranslate } from "react-admin";

import ButtonOrMenuItem from "atoms/ButtonOrMenuItem";
import EdmDialog from "molecules/EdmDialog";
import ExportDialog from "./ExportDialog";

export default function ExportDialogButton(props) {
  const { fetchEntities = undefined, closeMenu, variant, color, size, sx, ...rest } = props;
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoadingError, setHasLoadingError] = useState(false);
  const translate = useTranslate();

  const closeDialog = () => setDialogIsOpen(false);

  const openDialog = async () => {
    if (fetchEntities) {
      setDialogIsOpen(true);
      setIsLoading(true);

      try {
        await fetchEntities();
      } catch {
        setHasLoadingError(true);
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      setDialogIsOpen(true);
    }
  };

  const uniqIdsCount = props.selectedIds ? _uniq(props.selectedIds).length : 0;
  const translatedResource = translate(`resources.${props.resource}.name`, {
    smart_count: uniqIdsCount,
  });
  const defaultLabel = translate("export.actions.resource", {
    resource: translatedResource,
  });

  return (
    <Fragment>
      <ButtonOrMenuItem
        onClick={openDialog}
        label={props.label || "export.actions.export"}
        labelOpts={{ resource: translatedResource }}
        closeMenu={closeMenu}
        data-testid={`select-export-fields-${closeMenu ? "menu-item" : "button"}`}
        sx={sx}
        variant={variant}
        color={color}
        size={size}
      >
        <ExportIcon />
      </ButtonOrMenuItem>

      <EdmDialog
        maxWidth="lg"
        fullWidth
        open={dialogIsOpen}
        onClose={closeDialog}
        title={
          hasLoadingError ? (
            translate("export.error")
          ) : (
            <Fragment>
              {!isLoading && props.selectedIds && uniqIdsCount} {defaultLabel}
            </Fragment>
          )
        }
      >
        {() => (
          <>
            {(isLoading || (!isLoading && hasLoadingError)) && (
              <>
                {isLoading && <LinearProgress timeout={0} />}
                {!isLoading && hasLoadingError && <p>{translate("ra.message.error")}</p>}
              </>
            )}

            {!isLoading && !hasLoadingError && dialogIsOpen && <ExportDialog {...rest} closeDialog={closeDialog} />}
          </>
        )}
      </EdmDialog>
    </Fragment>
  );
}
